<template>
  <el-tooltip :disabled="disabled" :effect="effect || 'dark'" :placement="placement || 'top'">
    <template #content>
      <div class="wm-text-overflow__content">
        <p v-for="(item, index) in sentenceList" :key="index">{{ item }}</p>
      </div>
    </template>
    <div ref="trigger" class="wm-text-overflow__trigger">
      {{ text }}
    </div>
  </el-tooltip>
</template>

<script setup>
  import { debounce } from 'lodash'
  import { ref, computed, defineProps, onMounted, onUnmounted, watch, nextTick } from 'vue'

  const props = defineProps({
    text: {
      type: String,
      required: true,
    },
    placement: String,
    effect: String,
  })

  const trigger = ref()
  const disabled = ref(false)

  const checkShowTooltip = debounce(() => {
    const el = trigger.value
    disabled.value = el.scrollWidth <= el.clientWidth
  }, 100)

  watch(
    () => props.text,
    () => nextTick(checkShowTooltip)
  )

  onMounted(() => {
    checkShowTooltip()
    window.addEventListener('resize', checkShowTooltip)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', checkShowTooltip)
  })

  const sentenceList = computed(() => props.text.split(/\n/).map((e) => e.trim()))
</script>

<style lang="scss" scoped>
  .wm-text-overflow {
    &__trigger {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__content {
      max-width: 50vw;
      max-height: 300px;
      overflow-y: auto;

      p {
        margin: 2px 0;
        line-height: 1.25;
      }
    }
  }
</style>
